module.exports = __webpack_public_path__ + "img/phonePic.1d8b3088.jpg";